import React from 'react'

import { Form, Input, Select, InputNumber } from 'antd'
import PropTypes from 'prop-types'
import { EnFormItem } from '../shared/LocalizedFields'

const GenreForm = ({
  form,
  nameKZ,
  nameRU,
  nameEN,
  index,
  status,
  setFile,
  fileRef
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <>Изорбражение</>
      <input
        style={{ marginBottom: '3%' }}
        type="file"
        accept="image/*"
        ref={fileRef}
        onChange={event => setFile(event.target.files[0])}
      />
      <FormItem
        key="status"
        label="Статус документа"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Автивный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="index"
        label="Очередность Жанра"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите Очередность Документа`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>
      <FormItem
        key="nameKZ"
        label="Название(каз)"
        name="nameKZ"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Жанра на казахском`
          }
        ]}
        initialValue={nameKZ}
      >
        <Input placeholder="Аты" />
      </FormItem>
      <FormItem
        key="nameRU"
        label="Название(рус)"
        name="nameRU"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название Жанра на русском`
          }
        ]}
        initialValue={nameRU}
      >
        <Input placeholder="Название" />
      </FormItem>
      <EnFormItem name="nameEN" label="Название(англ)" initialValue={nameEN} />
    </Form>
  )
}

GenreForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  name: PropTypes.string
}

GenreForm.defaultProps = {
  nameKZ: '',
  nameRU: '',
  nameEN: '',
  index: null,
  status: 'active'
}

export default GenreForm
